// src/api/momenPublikApi.js
// Kirim momen dari masyarakat -> tabel temporary_momen (menunggu verifikasi admin).
import axios from "axios";

const BASE_URL = "https://berkah.bondowosokab.go.id:5500";
const API_KEY = "7039338ec2fa8ac649760ddd8404b711b207479377c846d41d5d24b7b21beb97";

// formData: judul_momen, deskripsi, tanggal_ambil, nama_pengirim, kontak_pengirim,
//           website (honeypot, harus kosong), foto[] (maks 5 gambar)
export async function kirimMomen(formData) {
    const res = await axios.post(`${BASE_URL}/momen-publik`, formData, {
        headers: { "Bondowoso-Berkah": API_KEY },
        timeout: 120000,
    });
    return res?.data?.response?.message || res?.data?.message || "Terkirim";
}